import is from '@sindresorhus/is';

import type {
    SectionVisibilityBase,
    UserProfileVisibilityBase,
    UserProfileVisibilityResponse,
} from '../../../../../../shared/source/data-contract/profile-visibility';
import type { SectionVisibilityResponse } from '../../../../../../shared/source/data-contract/profile-visibility';
import type { TranslationKey } from '../../../../../../shared/source/internationalization/translation';

export const getSectionVisibilityMessage = ({
    everyone,
    roles,
    users,
}: {
    readonly everyone: SectionVisibilityResponse['everyone'];
    readonly roles: SectionVisibilityResponse['roles'];
    readonly users: SectionVisibilityResponse['users'];
}): TranslationKey => {
    if (everyone) {
        return 'pages.user-profile.profile-visibility.drawer.apply-settings-to.visible-to-everyone';
    }

    if (is.nonEmptyArray(roles) || is.nonEmptyArray(users)) {
        return `pages.user-profile.profile-visibility.drawer.apply-settings-to.visible-to-roles-and-users`;
    }

    return 'pages.user-profile.profile-visibility.drawer.apply-settings-to.visible-to-me';
};

export const hasInitiallyAppliedSectionSettingsCheck = (
    section: SectionVisibilityResponse,
    sectionTemplate: SectionVisibilityBase,
): boolean =>
    is.emptyArray(section.users) &&
    section.everyone === sectionTemplate.everyone &&
    section.roles.every((it) => sectionTemplate.roles.includes(it)) &&
    sectionTemplate.roles.every((it) => section.roles.includes(it));

export const hasInitiallyAppliedSettingsCheck = (
    data: UserProfileVisibilityResponse,
    template: UserProfileVisibilityBase,
): boolean => {
    return (
        hasInitiallyAppliedSectionSettingsCheck(data.skillsVisibility, template.skillsVisibility) &&
        hasInitiallyAppliedSectionSettingsCheck(data.ambitionsVisibility, template.ambitionsVisibility) &&
        hasInitiallyAppliedSectionSettingsCheck(data.historyVisibility, template.historyVisibility) &&
        hasInitiallyAppliedSectionSettingsCheck(data.personalInfoVisibility, template.personalInfoVisibility)
    );
};
